import React from 'react'
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline'

interface MobileMenuButtonProps {
  openNav: boolean
  // eslint-disable-next-line no-unused-vars
  setOpenNav: (value: boolean) => void
}

export const MobileMenuButton = ({
  openNav,
  setOpenNav,
}: MobileMenuButtonProps) => (
  <button
    type="button"
    className="lg:hidden"
    onClick={() => setOpenNav(!openNav)}
    aria-label="Ouvrir le menu"
  >
    {openNav ? (
      <XMarkIcon className="w-6 h-6 text-blue-gray-500" strokeWidth={2} />
    ) : (
      <Bars3Icon className="w-6 h-6 text-blue-gray-500" strokeWidth={2} />
    )}
  </button>
)
